<template>
  <svg
    width="88"
    height="77"
    viewBox="0 0 88 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.8022 9.92026H73.2223C75.9837 9.92026 78.2223 12.1588 78.2223 14.9203V46.7669H24.8022V9.92026Z"
      fill="#92CAE9"
    />
    <path
      d="M0 5C0 2.23858 2.23858 0 5 0H26.0741V77H5.99999C2.68629 77 0 74.3137 0 71V5Z"
      fill="#92CAE9"
    />
    <path d="M26.3284 0L31.2852 9.92025H21.3717L26.3284 0Z" fill="#92CAE9" />
    <path
      d="M9.73814 20.0378L1.2868 71.1849C0.783557 74.2304 3.13304 77 6.21991 77H73.6547C76.1015 77 78.1889 75.2292 78.5878 72.8151L87.0391 21.6681C87.5424 18.6225 85.1929 15.8529 82.106 15.8529H14.6712C12.2244 15.8529 10.137 17.6237 9.73814 20.0378Z"
      fill="#7BB6D8"
      stroke="#7BB6D8"
    />
  </svg>
</template>

<script>
export default {
  name: "OpenFolder"
};
</script>
